import { ArrowForward, DirectionsBoat } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { LocationFormField } from "./LocationFormField";

export const LocationStatus = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <ArrowForward style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Status")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <LocationFormField label={t("Equipment")} type="checkBox" code="LocationEquipmentStatus" data={dataState} setData={setDataState} />
            <LocationFormField label={t("Place")} type="checkBox" code="LocationPlaceStatus" data={dataState} setData={setDataState} />
            <LocationFormField label={t("Port")} type="checkBox" code="LocationPortStatus" data={dataState} setData={setDataState} />
            <LocationFormField label={t("Terminal")} type="checkBox" code="LocationTerminalStatus" data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}